goog.provide("shadow.js.shim.module$src$svg$shapes$square$square_inset_center_dashed_svg$default");
shadow.js.shim.module$src$svg$shapes$square$square_inset_center_dashed_svg$default = shadow.js.shim.module$src$svg$shapes$square$square_inset_center_dashed_svg.default;
